// extracted by mini-css-extract-plugin
module.exports = {"div":"InteractiveDiv-module__div___1VcwO"};